var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("CollapsableListItem", {
    staticClass: "item mb-2",
    class: { current: _vm.isCurrent },
    attrs: { "max-height": 100 },
    nativeOn: {
      click: function ($event) {
        return _vm.onClick.apply(null, arguments)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v("Sent:"),
              ]),
              _vm._v(" " + _vm._s(_vm.formattedSent)),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v("Sender:"),
              ]),
              _vm._v(" " + _vm._s(_vm.emailAddressTextRepresentation)),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v("Recipient:"),
              ]),
              _vm._v(" " + _vm._s(_vm.contactTextRepresentation)),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v("Subject:"),
              ]),
              _vm._v(" " + _vm._s(_vm.subject)),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [_c("div", { domProps: { innerHTML: _vm._s(_vm.body) } })]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }